import { Card, CardHeader, Col, Progress } from "reactstrap";
import { H3, H4, Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { CommonTotalDetailsBody } from "./CommonTotalDetailsBody";
import { TOTAL_DETAILS_DATA } from "../../../Data/Dashboard";

const TotalDetails = () => {
  return (
    <>
      {TOTAL_DETAILS_DATA.map((item, index) => (
        <Col xl="4" sm="12" lg="4" md={item.md} className="box-col-4" key={index}>
          <Card className={item.class}>
            <CardHeader className="card-no-border">
              <div className="d-flex justify-content-between">
                <div className="flex-grow-1">
                  <H4>{item.title}</H4>
                  <H3>{item.data}</H3>
                  <Progress striped value={item.progress} color={item.progressColor} />
                </div>
                <div className="flex-shrink-0">
                  <Image src={dynamicImage(`dashboard-2/total-icon/${item.image}`)} alt="" />
                </div>
              </div>
            </CardHeader>
            <CommonTotalDetailsBody icon={item.icon} iconClass={item.iconClass} profit={item.profit} profitColor={item.profitColor} />
          </Card>
        </Col>
      ))}
    </>
  );
};

export default TotalDetails;
